export enum AttachmentType {
    URL = 'URL',
    UPLOAD = 'UPLOAD',
    FILE = 'FILE'
}
